import { Component } from '@angular/core';
import { EmployeeConfirmationService } from '../../../Model/EmployeeConfirmation/employee-confirmation.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { CommonService } from '../../../Model/Common/common.service';
import { UserRightService } from '../../../Model/UserRight/user-right.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { NgSelectModule } from '@ng-select/ng-select';
import moment from 'moment';
import { UtilityService } from '../../../Model/utility/utility.service';

@Component({
  selector: 'app-emp-confirmation-approval-detail',
  standalone: true,
  imports: [CommonModule, DataTablesModule, FormsModule, RouterModule, LoaderComponent, NgbDatepickerModule, NgSelectModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './emp-confirmation-approval-detail.component.html',
  styleUrl: './emp-confirmation-approval-detail.component.scss'
})
export class EmpConfirmationApprovalDetailComponent {
  isDisabled: boolean = false;
  isSuper: boolean = false;//for super admin
  GetID = 0;//1-detail,2-request
  isApprovalLavel = true;
  DetailData = {
    WebESSApprovalRequestTrackingId: null as any,
    TransactionId: null as any,
    EmpMasterId: null as any,
    EmpCode: null,
    Photo: null as any,
    EmployeeName: null as any,
    BranchName: null,
    ClientLocation: null,
    DesignationMasterId: null,
    DesignationName: null,
    RequestDate: null,
    JoiningDate: null,
    JoiningDateObj: null as any,
    IsEmpConfirmed: null,
    ConfirmationDate: null,
    ProbationEndDate: null,
    WorkingStatus: null,
    ESS_QuestionnareTemplateMainId: null,
    TemplateName: null,
    InitiatorId: null,
    InitiatorName: null,
    InitiatedDate: null,
    IntimationTo: null,
    IntimationToName: null,
    InitimationOn: null,
    EmpType: null as any,
    ApprovalStatus: null as any,
    FromDateObj: null as any,
    ConfirmationExtendDate: null as any,
    ConfirmationExtendDateObj: null as any,
    ConfirmationExtendDateMinObj: null as any,
    IsManualAllowDate: false,
    DropdownType: 1,
    IsTerminated: false,
    ConfirmationRemark: null as any,
    AllowConfirmationBeforeDueDate: false
  };
  Trackings = [];
  TrackingsUser = [];
  user = [] as any;
  Datas = [] as any;
  DatasView = [] as any;
  DataEmpName = '';
  ViewDataEmpName = '' as any;
  RemarkViewAns = '';
  ViewOfType = '';

  Filter = {
    ModuleMasterId: 17,
    WebESSApprovalRequestTrackingId: 0,
    FromDate: null,
    ToDate: null,
    FromDateObj: null as any,
    ToDateObj: null as any,
    EmpMasterId: 0,
    EmpMappingId: 0,
    SelectType1: 'D',
    SelectType: null,
    TransactionId: 0,
    EmpType: null,
    Remark: null,
    isShowError: false,
  }

  QFilter = {
    SelectType: 'Approve',
    WebESSApprovalRequestTrackingId: 0,
    ESS_EmployeeConfirmationDetailsID: 0,
    EmpMasterId: null,
    ESS_EmployeeConfirmationHistoryDetails: [] as any,
    Remark: null,
    ConfirmationDate: null as any,
    IsTerminate: false,
  }

  toDayDate = null as any;

  constructor(
    private approvalMatrix: ApprovalMatrixService,
    private route: ActivatedRoute,
    private session: SessionService,
    private toast: ToastService,
    private router: Router,
    protected common: CommonService,
    protected dateFormate: CustomDateParserFormatter,
    private modalService: NgbModal,
    private employeeconfirmation: EmployeeConfirmationService,
    protected tooltip: TooltipService,
    private userright: UserRightService,
    private utility: UtilityService
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.route.params.subscribe(params => this.Filter.WebESSApprovalRequestTrackingId = parseInt(params['id']));
    this.QFilter.WebESSApprovalRequestTrackingId = this.Filter.WebESSApprovalRequestTrackingId;
    if (window.location.pathname.includes('todo')) {
      this.GetID = 1;
    } else if (window.location.pathname.includes('request')) {
      this.Filter.EmpMasterId = this.user.UserId;
      this.GetID = 2
    }
    // this.router.events.subscribe((val:any) => { if(val instanceof NavigationEnd){
    //   this.ngOnInit();
    // }});
  }

  ngOnInit(): void {
    this.SelectDate('RegistrationDate', null, null);
    if (this.user.UserType == 'E') {
      this.Filter.EmpMappingId = this.user.UserId;
    }
    if (this.GetID == 1) {
      this.ApprovalMatrixRequestGet();
      //if (this.user.UserType == 'A') {
      this.ESS_GetUserRole();
      //}
    } else if (this.GetID == 2) {
      this.ESS_EmployeeConfirmationDetailsSelectTable();
    }
  }

  Validate(form: any, SelectType: string) {
    if (form.valid) {
      this.ESS_EmployeeConfirmationQuestionnare(SelectType);
    }
    else {
      this.toast.show({ message: 'Please fill all form details', type: toastTypeEnum.warning });
      form.submitted = true;
    }
  }

  ApprovalMatrixRequestGet() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet(this.Filter).subscribe({
      next: (response) => {
        if (this.Filter.ModuleMasterId == 17) {
          if (response.Table.length > 0) {
            this.DetailData = response.Table[0];
          } else if (response.Table1.length > 0) {
            this.DetailData = response.Table1[0];
          } else if (response.Table2.length > 0) {
            this.DetailData = response.Table2[0];
          } else if (response.Table3.length > 0) {
            this.DetailData = response.Table3[0];
          }

          if (this.DetailData.ConfirmationDate != null && this.DetailData.ConfirmationDate != '') {
            this.DetailData.ConfirmationExtendDateObj = this.dateFormate.parse(this.DetailData.ConfirmationDate);
            this.DetailData.ConfirmationExtendDateMinObj = this.dateFormate.parse(this.DetailData.ConfirmationDate);
          }

          if (this.DetailData.JoiningDate != null && this.DetailData.JoiningDate != '') {
            this.DetailData.JoiningDateObj = this.dateFormate.parse(this.DetailData.JoiningDate);
          }

          this.DetailData.DropdownType = 1;
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.ApprovalMatrixRequestGetTracking();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestGetTracking() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet({ ModuleMasterId: this.Filter.ModuleMasterId, FromDate: '', ToDate: '', EmpMasterId: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, SelectType1: 'ApprovalStatus', SelectType: '', TransactionId: this.DetailData.TransactionId }).subscribe({
      next: (response) => {
        if (response.Table.length == 0) {
          this.isApprovalLavel = false;
        }
        if (this.common.ToLowerCase(this.DetailData.ApprovalStatus) == 'pending') {
          if (this.user.UserType == 'A') {
            this.TrackingsUser = response.Table.filter((e: any) => e.ApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.ApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
            if (response.Table.filter((e: any) => e.ApproverId == this.user.UserId).length > 0) {
              this.DataEmpName = response.Table.filter((e: any) => e.ApproverId == this.user.UserId)[0]['ApproverName'] ?? '';
            }
          } else if (this.user.UserType == 'E') {
            this.TrackingsUser = response.Table.filter((e: any) => e.EmpApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.EmpApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
            if (response.Table.filter((e: any) => e.EmpApproverId == this.user.UserId).length > 0) {
              this.DataEmpName = response.Table.filter((e: any) => e.EmpApproverId == this.user.UserId)[0]['ApproverName'] ?? '';
            }
          }
        } else {
          this.Trackings = response.Table.sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
        }

        if (this.user.UserType == 'A') {
          if (response.Table.filter((e: any) => e.ApproverId == this.user.UserId).length > 0) {
            this.DataEmpName = response.Table.filter((e: any) => e.ApproverId == this.user.UserId)[0]['ApproverName'] ?? '';
          }
        } else if (this.user.UserType == 'E') {
          if (response.Table.filter((e: any) => e.EmpApproverId == this.user.UserId).length > 0) {
            this.DataEmpName = response.Table.filter((e: any) => e.EmpApproverId == this.user.UserId)[0]['ApproverName'] ?? '';
          }
        }

        if ((this.common.ToLowerCase(this.DetailData.ApprovalStatus) == 'pending' || !this.isSuper ||
          (this.user.UserType == 'A' && response.Table.filter((e: any) => e.ApproverId == this.user.UserId).length > 0) ||
          (this.user.UserType == 'E' && response.Table.filter((e: any) => e.EmpApproverId == this.user.UserId).length > 0))
          && !(this.common.ToLowerCase(this.DetailData.ApprovalStatus) == 'approved' && this.isSuper)) {
          this.ESS_EmployeeConfirmationDetailsSelect();
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestProcess(SelectType: string) {
    if (((SelectType == 'Reject' && this.Filter.Remark != '' && this.Filter.Remark != null) || SelectType == 'Approve') || this.isSuper) {
      this.isDisabled = true;
      //this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, approvedid: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
      this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
        next: (response) => {
          if (response.Error_Code == '49' || response.Error_Code == '50' || response.Error_Code == '51') {
            const modalRef = this.modalService.open(AlertSuccessComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message.replace('Rejected', this.DetailData.DropdownType == 3 ? 'Terminate' : 'Extended');
            modalRef.result.then((result: any) => {
              if (result) {
                this.Cancel();
              }
            });
          } else {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => { });
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.Filter.isShowError = true;
      this.toast.show({ message: 'Please enter remark', type: toastTypeEnum.warning });
    }
  }

  ESS_EmployeeConfirmationDetailsSelectTable() {
    this.isDisabled = true;
    this.employeeconfirmation.ESS_EmployeeConfirmationDetailsSelect({ SelectType: "ALL", ESS_EmployeeConfirmationDetailsId: this.Filter.WebESSApprovalRequestTrackingId, EmpMasterId: null, ApprovalStatus: this.isSuper ? this.DetailData.ApprovalStatus : 'All' }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.DetailData.WebESSApprovalRequestTrackingId = 0;
          this.DetailData.TransactionId = response.Table[0].ESS_EmployeeConfirmationDetailsID;
          this.DetailData.EmpMasterId = response.Table[0].EmpMasterId;
          this.DetailData.EmpCode = response.Table[0].EmpCode;
          this.DetailData.Photo = response.Table[0].Photo;
          this.DetailData.EmployeeName = response.Table[0].EmployeeName;
          this.DetailData.BranchName = response.Table[0].BranchName;
          this.DetailData.ClientLocation = response.Table[0].ClientLocation;
          this.DetailData.DesignationMasterId = response.Table[0].DesignationMasterId;
          this.DetailData.DesignationName = response.Table[0].DesignationName;
          this.DetailData.RequestDate = response.Table[0].RequestDate;
          this.DetailData.JoiningDate = response.Table[0].JoiningDate;
          this.DetailData.IsEmpConfirmed = response.Table[0].IsEmpConfirmed;
          this.DetailData.WorkingStatus = response.Table[0].WorkingStatus;
          this.DetailData.ConfirmationDate = response.Table[0].ConfirmationDate;
          this.DetailData.ProbationEndDate = response.Table[0].ProbationDate;
          this.DetailData.ESS_QuestionnareTemplateMainId = response.Table[0].ESS_QuestionnareTemplateMainId;
          this.DetailData.TemplateName = response.Table[0].TemplateName;
          this.DetailData.InitiatorId = response.Table[0].InitiatorId;
          this.DetailData.InitiatorName = response.Table[0].InitiatorName;
          this.DetailData.InitiatedDate = response.Table[0].InitiatedDate;
          this.DetailData.IntimationTo = response.Table[0].IntimationTo;
          this.DetailData.IntimationToName = response.Table[0].IntimationName;
          this.DetailData.InitimationOn = response.Table[0].InitimationOn;
          this.DetailData.EmpType = this.user.EmpType;
          this.DetailData.IsTerminated = response.Table[0].IsTerminated;
          this.DetailData.ApprovalStatus = response.Table[0].ApprovalStatus;

          this.DataEmpName = this.DetailData.EmployeeName;
        }
        this.isDisabled = false;
      },
      complete: () => { this.ApprovalMatrixRequestGetTracking(); },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_EmployeeConfirmationDetailsSelect() {
    this.isDisabled = true;
    this.employeeconfirmation.ESS_EmployeeConfirmationDetailsSelect({ SelectType: "ALL", ESS_EmployeeConfirmationDetailsId: this.DetailData.TransactionId, EmpMasterId: null, ApprovalStatus: this.isSuper ? this.DetailData.ApprovalStatus : this.TrackingsUser.length == 0 ? 'All' : this.TrackingsUser[this.TrackingsUser.length - 1]['Status'] }).subscribe({
      next: (response) => {
        if (response.Table1) {
          this.QFilter.Remark = response.Table1[0].Remarks;
          if (response.Table1.filter((e: any) => (e.SubmittedBy == this.user.UserId)).length > 0) {
            this.Datas = response.Table1.filter((e: any) => (e.SubmittedBy == this.user.UserId)).sort((a: any, b: any) => {
              if (a.QuestionSequence === null || a.QuestionSequence === '' || b.QuestionSequence === null || b.QuestionSequence === '') {
                return -1;
              } else {
                return a.QuestionSequence - b.QuestionSequence;
              }
            });
          } else {
            this.Datas = response.Table1.filter((e: any) => (e.SubmittedBy == null || e.SubmittedBy == '' || e.SubmittedBy == 0)).sort((a: any, b: any) => {
              if (a.QuestionSequence === null || a.QuestionSequence === '' || b.QuestionSequence === null || b.QuestionSequence === '') {
                return -1;
              } else {
                return a.QuestionSequence - b.QuestionSequence;
              }
            });
          }
        }
        this.isDisabled = false;
      },
      complete: () => { this.isDisabled = false; },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_EmployeeConfirmationQuestionnare(SelectType: string) {
    if (((this.DetailData.DropdownType == 1 && this.DetailData.AllowConfirmationBeforeDueDate && (moment(this.dateFormate.format(this.DetailData.ConfirmationExtendDateObj), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormate.format(this.DetailData.JoiningDateObj), 'DD MMM YYYY')))) ||
      (this.DetailData.DropdownType == 1 && !this.DetailData.AllowConfirmationBeforeDueDate && (moment(this.dateFormate.format(this.DetailData.ConfirmationExtendDateObj), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormate.format(this.DetailData.ConfirmationExtendDateMinObj), 'DD MMM YYYY')))) ||
      (this.DetailData.DropdownType == 2 && (moment(this.dateFormate.format(this.DetailData.ConfirmationExtendDateObj), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormate.format(this.DetailData.ConfirmationExtendDateMinObj), 'DD MMM YYYY')))) ||
      (this.DetailData.DropdownType == 3 && (moment(this.dateFormate.format(this.DetailData.ConfirmationExtendDateObj), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormate.format(this.toDayDate), 'DD MMM YYYY')))))
      && this.DetailData.ConfirmationExtendDateObj != null && this.DetailData.ConfirmationExtendDateObj != ''
    ) {
      if (this.Datas.filter((e: any) => this.common.ToLowerCase(e.AnswerIsText) == 's' && parseInt(e.Score) > 5).length == 0) {
        if (((SelectType == 'Reject' && this.Filter.Remark != '' && this.Filter.Remark != null) || SelectType == 'Approve') || this.isSuper) {
          const modalRef = this.modalService.open(ConfirmationComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = 'Do you want to ' + (SelectType == 'Reject' ? this.DetailData.DropdownType == 3 ? 'Terminate' : 'Extend' : SelectType) + '?';
          modalRef.result.then((result: any) => {
            if (result) {
              this.isDisabled = true;
              this.QFilter.SelectType = SelectType;
              this.QFilter.ESS_EmployeeConfirmationDetailsID = this.DetailData.TransactionId;
              this.QFilter.ESS_EmployeeConfirmationHistoryDetails = [];
              this.QFilter.ConfirmationDate = this.dateFormate.format(this.DetailData.ConfirmationExtendDateObj);
              this.QFilter.IsTerminate = this.DetailData.DropdownType == 3 ? true : false;
              this.Datas.forEach((element: any) => {
                this.QFilter.ESS_EmployeeConfirmationHistoryDetails.push({
                  ESS_QuestionnareTemplateDetailsId: element.ESS_QuestionnareTemplateDetailsId,
                  Questions: element.Questions,
                  Answer: this.common.ToLowerCase(element.AnswerIsText) == 't' ? element.Answer : null,
                  Score: this.common.ToLowerCase(element.AnswerIsText) == 's' ? parseFloat(element.Score) : null,
                  Remarks: null
                });
              });
              this.employeeconfirmation.ESS_EmployeeConfirmationQuestionnare(this.QFilter).subscribe({
                next: (response) => {
                  if (response.Error_Code == '511') {
                    this.ApprovalMatrixRequestProcess(SelectType)
                  } else {
                    this.isDisabled = false;

                    const modalRef = this.modalService.open(AlertWarningComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = response.Error_Message;
                    modalRef.result.then((result: any) => { });
                  }
                },
                complete: () => { },
                error: (error) => {
                  this.isDisabled = false;
                },
              });
            }
          }).catch(() => { });
        } else {
          this.Filter.isShowError = true;
          this.toast.show({ message: 'Please enter remark', type: toastTypeEnum.warning });
        }
      } else {
        this.toast.show({ message: 'Please enter score between 1 to 5', type: toastTypeEnum.warning });
      }

    } else {
      if (this.DetailData.ConfirmationExtendDateObj != null && this.DetailData.ConfirmationExtendDateObj != '') {
        this.toast.show({ message: this.DetailData.DropdownType == 1 ? 'Confirmation must be greater than or equal to ' + this.dateFormate.format(this.DetailData.JoiningDateObj) : this.DetailData.DropdownType == 2 ? 'Extend must be greater than or equal to ' + this.dateFormate.format(this.DetailData.ConfirmationExtendDateMinObj) : 'Terminate date must be greater than or equal to ' + this.dateFormate.format(this.toDayDate), type: toastTypeEnum.warning });
      } else {
        this.toast.show({ message: 'Please select date', type: toastTypeEnum.warning });
      }

    }
  }

  Link(Text: string) {
    return this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'EmployeeLeaveAttachment' + '/' + Text;
  }

  Cancel() {
    if (this.GetID == 1) {
      if (this.user.UserType == 'A') {
        this.router.navigate(['/todo/employeeconfirmation/']);
      } else if (this.user.UserType == 'E') {
        this.router.navigate(['/request/questionnaire/approval/']);
      }
    } else if (this.GetID == 2) {
      this.router.navigate(['/request/questionnaire/']);
    }
  }

  ESS_GetUserRole() {
    this.isDisabled = true;
    try {
      this.userright.ESS_GetUserRole({ SelectType: 'S', EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
        next: (response) => {
          if (this.common.ToLowerCase(response.Table[0].UserRole) == 'superadmin') {
            this.isSuper = true;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } catch (e) {
      this.isDisabled = false;
    }
  }

  ViewUserAns(ViewOfType: string, ViewOfId: number, EmpName: String) {
    this.isDisabled = true;
    this.ViewOfType = ViewOfType == 'E' ? 'Employee' : 'Admin';
    this.DatasView = [];
    this.ViewDataEmpName = EmpName;
    this.employeeconfirmation.ESS_EmployeeConfirmationDetailsSelect({ ViewOfType: ViewOfType, ViewOfId: ViewOfId, SelectType: "ViewOf", ESS_EmployeeConfirmationDetailsId: this.DetailData.TransactionId, EmpMasterId: null, ApprovalStatus: 'All' }).subscribe({
      next: (response) => {
        if (response.Table1) {
          this.RemarkViewAns = response.Table1[0].Remarks;
          this.DatasView = response.Table1.sort((a: any, b: any) => {
            if (a.QuestionSequence === null || a.QuestionSequence === '' || b.QuestionSequence === null || b.QuestionSequence === '') {
              return -1;
            } else {
              return a.QuestionSequence - b.QuestionSequence;
            }
          });
        }
        this.isDisabled = false;
      },
      complete: () => { this.isDisabled = false; },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  StatusReplace(status: String) {
    return this.common.ToLowerCase(status) == 'rejected' ? this.DetailData.IsTerminated ? 'Terminated' : 'Extended' : status;
  }

  SetDateForConfirmatin() {
    if (this.DetailData.DropdownType == 1) {
      if (this.DetailData.ConfirmationDate != null && this.DetailData.ConfirmationDate != '') {
        this.DetailData.ConfirmationExtendDateObj = this.dateFormate.parse(this.DetailData.ConfirmationDate);
      } else {
        this.DetailData.ConfirmationExtendDateObj = null;
      }
    } else if (this.DetailData.DropdownType == 2) {
      if (this.DetailData.ConfirmationExtendDate != null && this.DetailData.ConfirmationExtendDate != '') {
        this.DetailData.ConfirmationExtendDateObj = this.dateFormate.parse(this.DetailData.ConfirmationExtendDate);
      } else {
        this.DetailData.ConfirmationExtendDateObj = null;
      }
    } else if (this.DetailData.DropdownType == 3) {
      if (this.toDayDate != null && this.toDayDate != '') {
        this.DetailData.ConfirmationExtendDateObj = this.toDayDate;
      } else {
        this.DetailData.ConfirmationExtendDateObj = null;
      }
    }
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.toDayDate = this.dateFormate.parse(response.Table[0].RegistrationDate);
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  removeError() {
    this.Filter.isShowError = false;
  }
}
